import React, { useEffect, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface AuthMiddlewareProps {
  requiresAuthentication?: boolean;
  requiresValidation?: boolean;
  children: ReactNode;
}

const AuthMiddleware: React.FC<AuthMiddlewareProps> = ({
  children,
  requiresAuthentication,
  requiresValidation,
}) => {
  const navigate = useNavigate();
  const userToken = useSelector((state) => state.entities.auth.userToken);
  const { userData } = useSelector((state) => state.entities.user);

  useEffect(() => {
    // Redirect based on authentication and validation requirements
    if (requiresAuthentication && (!userToken || userToken === "undefined")) {
      navigate("/login");
    } else if (
      requiresValidation &&
      userData &&
      (!userData.is_validated || userData.is_validated === "undefined")
    ) {
      navigate("/verify-account");
    }
  }, [
    userData,
    userToken,
    navigate,
    requiresAuthentication,
    requiresValidation,
  ]);

  // Render the wrapped children if all requirements are met
  return requiresValidation &&
    (!userToken || (userData && !userData.is_validated)) ? null : (
    <React.Fragment>{children}</React.Fragment>
  );
};

export default AuthMiddleware;
